export default "__VITE_ASSET__DBTwGe6z__"